export default {
  root: {
    backgroundColor: 'transparent'
  }
};
